<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        data() {
            return {
                isAuthorized: false,
                list: []
            }
        },
        mounted() {
            if(this.adminOnly()) {
                this.list = [
                    {
                        title: 'Карточка',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}`
                    },
                    {
                        title: 'Редактировать',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/edit`
                    },
                    {
                        title: 'Описание',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/description`
                    },
                    {
                        title: 'Дополнительное описание',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/additional-description`
                    },
                    {
                        title: 'Категории',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/categories`
                    },
                    {
                        title: 'Продукция',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/products`
                    },
                    {
                        title: 'Опции',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/options`
                    },
                    {
                        title: 'Варианты',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/variants`
                    },
                    {
                        title: 'Импорт',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/import`
                    },
                    {
                        title: 'Акции',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/promotions`
                    },
                    {
                        title: 'Дополнительно',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/additional`
                    },
                    {
                        title: 'Словарь',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/dictionary`
                    },
                    {
                        title: 'Доставка',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/delivery`
                    },
                    {
                        title: 'Перенаправление доставки',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/delivery-address-redirect`
                    },
                    {
                        title: 'Настройки по башням',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/tower-settings`
                    },
                    {
                        title: 'Настройки',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/settings`
                    },
                ]
            } else {
                this.list = [
                    {
                        title: 'Карточка',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}`
                    },
                    {
                        title: 'Редактировать',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/edit`
                    },
                    {
                        title: 'Описание',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/description`
                    },
                    {
                        title: 'Категории',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/categories`
                    },
                    {
                        title: 'Продукция',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/products`
                    },
                    {
                        title: 'Опции',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/options`
                    },
                    {
                        title: 'Варианты',
                        url: `/entities/${this.$route.params.code}/${this.$route.params.id}/variants`
                    },
                ]
            }
        },
        methods: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        }
    }
</script>
